// Links and origins that more than one screen needs, so they can't drift apart.

// The extension's listing. The sign-up wizard once linked to a store URL without
// the extension id, which lands on the Chrome Web Store home page.
export const CHROME_STORE_URL = 'https://chromewebstore.google.com/detail/timekeep/bkefhociggnbmpfcjciekflhaphhehpp';

// Where links in emails (team invitations) should point. The page's own origin,
// so local dev and staging link to themselves, except for the legacy host: it
// still serves the app, but emailed links belong on the real domain.
export function appOrigin() {
  const o = window.location.origin;
  return o.includes('gptimekeep.netlify.app') ? 'https://usetimekeep.com' : o;
}

export const inviteUrl = (token) => `${appOrigin()}/accept-invite?token=${token}`;
